module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showFilterDialog),
      callback: function($$v) {
        _vm.showFilterDialog = $$v
      },
      expression: "showFilterDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleFilter()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.target),
      callback: function($$v) {
        _vm.target = $$v
      },
      expression: "target"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Marken",
      "value": "marken"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Firmen",
      "value": "firmen"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Types Filter",
      "multiple": "",
      "chips": "",
      "dark": "",
      "cache-items": "",
      "items": _vm.dialogTypes,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filterTypes),
      callback: function($$v) {
        _vm.filterTypes = $$v
      },
      expression: "filterTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Warengruppen Filter",
      "autocomplete": "",
      "multiple": "",
      "chips": "",
      "dark": "",
      "cache-items": "",
      "items": _vm.dialogWarengruppen,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filterWarengruppen),
      callback: function($$v) {
        _vm.filterWarengruppen = $$v
      },
      expression: "filterWarengruppen"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.engageFilter
    }
  }, [_vm._v("\n                Filter\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a38ceea0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FilterModal.vue
// module id = 339
// module chunks = 0